var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("img", {
      staticClass: "account-verification__step__icon",
      class: _vm.additionalCustomIconStyles,
      attrs: { src: _vm.icon },
    }),
    _vm._v(" "),
    _c("h1", { staticClass: "account-verification__step__title" }, [
      _vm._v("\n    " + _vm._s(_vm.title) + "\n  "),
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "account-verification__step__description" }, [
      _vm._v("\n    " + _vm._s(_vm.description) + "\n  "),
    ]),
    _vm._v(" "),
    _c(
      "p",
      {
        staticClass:
          "account-verification__step__description account-verification__step__data",
      },
      [_vm._v("\n    " + _vm._s(_vm.confirmationData) + "\n  ")]
    ),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.passcode,
          expression: "passcode",
        },
      ],
      ref: "passcodeTxt",
      staticClass: "passcode",
      class: _vm.additionalPasscodeInputStyles,
      attrs: { type: "text", maxlength: "6", spellcheck: "false" },
      domProps: { value: _vm.passcode },
      on: {
        input: function ($event) {
          if ($event.target.composing) {
            return
          }
          _vm.passcode = $event.target.value
        },
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }